import React from 'react'
import { ProductBox } from './product-box'
import { PayrollProductImage } from '../../../product-image/payroll-product-image'
import { HaulerProductImage } from '../../../product-image/hauler-product-image'
import { HaulerNextProductImage } from '../../../product-image/hauler-next-product-image'
import { LabProductImage } from '../../../product-image/lab-product-image'
import { PrincipalProductImage } from '../../../product-image/principal-product-image'

export default function AppSection() {
  return (
    <main id="main">
      <section id="about" className="about">
        <div className="container">
          <div className="row content">
            <div className="col-lg-6">
              <h2>Application suite tailored for dairy business operations.</h2>
              <h3>
                We have a solution from milk hauling, milk sample testing, milk components values computation until sending checks to milk producer.{' '}
              </h3>
            </div>
            <div className="col-lg-6 pt-4 pt-lg-0 services">
              <div className="row no-gutters ">
                <ProductBox
                  url="https://payroll.totalmilk.com"
                  title="Total Milk Payroll"
                  description="Our main app for producer payroll computations."
                  moreInfoUrl={'/payroll'}
                  productImage={<PayrollProductImage />}
                />

                <ProductBox
                  url="https://hauler.totalmilk.com/"
                  title="Total Milk Hauler"
                  description="Driver and hauler app for milk hauling management."
                  moreInfoUrl={'/hauler'}
                  productImage={<HaulerProductImage />}
                />

                <ProductBox
                  url="https://hauler.totalmilk.com"
                  title="Total Milk Hauler Next"
                  description="Next-generation hauling platform — modern web back-office and redesigned driver mobile app working as one."
                  moreInfoUrl={'/hauler-next'}
                  productImage={<HaulerNextProductImage />}
                />

                <ProductBox
                  url="https://lab.totalmilk.com/"
                  productImage={<LabProductImage />}
                  title="Total Milk Laboratory"
                  description="Lab and Payroll integration for milk components test results."
                  moreInfoUrl={'/lab'}
                />

                <ProductBox
                  url="https://principal.totalmilk.com/"
                  productImage={<PrincipalProductImage />}
                  title="Total Milk Principal"
                  description="Producer and Principal portal to access test results, milk pickup, and even checks and history."
                  moreInfoUrl={'/principal'}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
